import { ApiService } from './api.service';
import { AppConsts } from '@shared/AppConsts';

export abstract class BaseApiService {
  protected abstract prefix: string;
  private baseUrl = AppConsts.remoteServiceBaseUrlNew;

  constructor(protected api: ApiService) { }

  protected fullUrl(endpoint: string): string {
    if (endpoint.startsWith('http')) return endpoint;
    return `${this.baseUrl}${this.prefix}${endpoint}`;
  }

  protected get<T>(endpoint: string, params?: any) {
    return this.api.get<T>(this.fullUrl(endpoint), params);
  }

  protected getBlob(endpoint: string, params?: any) {
    return this.api.getBlob(this.fullUrl(endpoint), params);
  }

  protected postBlob(endpoint: string, params?: any) {
    return this.api.postBlob(this.fullUrl(endpoint), params);
  }

  protected upload<T>(endpoint: string, formData: FormData, params?: any) {
    return this.api.upload<T>(this.fullUrl(endpoint), formData, params);
  }

  protected post<T>(endpoint: string, body: any, params?: any) {
    return this.api.post<T>(this.fullUrl(endpoint), body, params);
  }

  protected put<T>(endpoint: string, body: any, params?: any) {
    return this.api.put<T>(this.fullUrl(endpoint), body, params);
  }

  protected delete<T>(endpoint: string, params?: any) {
    return this.api.delete<T>(this.fullUrl(endpoint), params);
  }
}